// eslint-disable-next-line no-unused-vars
import React from 'react'
import { IClinique } from 'components/core/types'
import GoogleRating from 'components/ui/GoogleRating'
import IconPhone from 'assets/images/icon-phone-blue.svg'
import { css, StyleSheet } from 'aphrodite'
import Styles from 'components/ui/Styles'
import constants from 'utils/constants'
import ucfirst from 'utils/ucfirst'

interface GoogleMapInfoWindowProps {
  clinique: IClinique,
  mobile?: boolean,
  t: (key: string) => string,
}

const GoogleMapInfoWindow = ({ clinique, mobile, t }: GoogleMapInfoWindowProps) => {
  if (!clinique) {
    return null
  }
  const {
    title,
    acf: {
      phone,
      marker_image: {
        url,
      } = {},
      subtitle,
    },
    link,
    google_datas,
  } = clinique

  const {
    result: {
      rating = null,
      user_ratings_total = null,
    } = {},
  } = google_datas ?? {}

  const leftBlock = !!url || (!!google_datas && (rating || user_ratings_total))
  const containerStyles = [
    css(styles.container),
    'tw-text-black',
    'tw-flex',
    !mobile ? 'tw-gap-5' : 'tw-gap-4',
    !mobile ? 'tw-flex-row' : 'tw-flex-col',
  ].join(' ')
  const phoneStyles = [
    !mobile ? 'tw-text-lg' : css(styles.text13),
    'tw-ml-2',
    'tw-text-background',
    'tw-font-light',
  ].join(' ')
  const buttonStyle = css(Styles.button, styles.button)
  const infosStyles = [
    css(styles.buttonContainer, styles.mTop10),
    `lg:${css(styles.mTop20)}`,
    'tw-flex',
    'tw-flex-col',
    'lg:tw-flex-row',
  ].join(' ')
  return (
    <div className={containerStyles}>
      {leftBlock && (
        <div className="tw-w-36">
          {!!url && (<div className="tw-hidden lg:tw-block"><img src={url} width="136" height="86" alt={title} /></div>)}
          {!!google_datas && rating && <GoogleRating rating={rating} />}
          {!!google_datas && user_ratings_total && (
            <div className="tw-text-green tw-text-sm">
              {user_ratings_total}
              {' reviews'}
            </div>
          )}
        </div>
      )}
      <div>
        <div className="tw-text-background tw-text-sm tw-mt-2.5 tw-mb-1.5">{subtitle}</div>
        <div className="tw-text-lg tw-text-dark-green tw-uppercase tw-font-extrabold">{title}</div>
        {!!phone && (
          <div className="tw-mt-1.5">
            <a href={`tel:${phone}`} className="tw-flex tw-items-center">
              <img src={IconPhone} alt="téléphone" />
              <div className={phoneStyles}>{phone}</div>
            </a>
          </div>
        )}
        <div className={infosStyles}>
          <a
            href={link}
            className={`${buttonStyle} primary-btn tw-mt-2.5 tw-whitespace-nowrap`}
            target="_blank"
            rel="noreferrer"
          >
            {ucfirst(t('infos'))}
          </a>
          <a
            href="#appointment"
            className={`${buttonStyle} gmap-appointment primary-btn tw-mt-2.5 tw-whitespace-nowrap`}
          >
            {t('appointment')}
          </a>
        </div>
      </div>
    </div>
  )
}
GoogleMapInfoWindow.defaultProps = {
  mobile: false,
}
const styles = StyleSheet.create({
  button: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: constants.colors.green,
    fontSize: 13,
    padding: '7px 20px',
    marginRight: 30,
    lineHeight: 'normal',
    textTransform: 'uppercase',
    width: 'fit-content',
  },
  buttonContainer: {
    fontFamily: 'Public Sans, sans-serif',
  },
  mTop10: {
    marginTop: '10px',
  },
  mTop20: {
    marginTop: '20px',
  },
  container: {
    fontFamily: 'Public Sans, sans-serif',
    padding: 15,
  },
  text13: {
    fontSize: 13,
  },
})
export default GoogleMapInfoWindow
